import { Component, Inject, OnInit } from '@angular/core';
import { LayoutService, NavigationResource, UserPermission, UserDetails, LoadingService, } from '@control-tower/lib';
import { UserApplication } from './models/application/user-application.model';
import { ResourceConstant } from './shared/constants/resource-constant';
import { Config } from './config';
import { AppMenuService } from './core/app-menu.service';
import { UserService } from './core/user.service';
import { LeftMenu } from './shared/constants/navigation-constants';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ct-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{

  isLoading = false;

  // @see {@link https://fontawesome.com/v4/icons/} for icon list
  constructor(
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
    private layoutService: LayoutService,
    private userService: UserService,
    private appMenuService: AppMenuService,
    public loadingService: LoadingService
  ) {
    // Empty
  }

  ngOnInit(){
    if (this.oktaAuth) {
      this.oktaAuth.getUser().then(async user => {
        if(user) {
          Config.user.name = user.preferred_username ?? '';
          Config.user.iNumber = Config.user.name.split('@')[0];
          await this.userService.loadUserInfo();
          await this.loadUserProfile();
        }

      });

    }

    if (this.userService.isDeveloperUser()) {
      // Experimental features enabled for Developers
      Config.FEATURES.set('isQuestionEditorEnabled', true);
      Config.FEATURES.set('isQuestionDialogEditor', false);
      Config.FEATURES.set('isQuestionToFormDropEnabled', true);
      Config.FEATURES.set('isHotKeysEnabled', true);
      Config.FEATURES.set('isMultipleSelectionEnabled', true);
      Config.FEATURES.set('isUndoRedoButtonEnabled', true);
      Config.FEATURES.set('isLocalQuestionLibraryEnabled', true);
      Config.FEATURES.set('isPreviewShowJSON', true);
      Config.FEATURES.set('isContextMenuEnabled', true);
      Config.FEATURES.set('isMultiScroll', true);
      // Question Editor Permission enabled for Developers
      this.userService.isDevQuestionEditor = true;
    }
    Config.FEATURES.set('isQuestionCommentEnabled', true);
  }

  async loadUserProfile() {
    const userInfo = this.userService.userInfo;
    const permissions = userInfo?.permissions || [];

    /* eslint-disable @typescript-eslint/naming-convention,@typescript-eslint/consistent-type-assertions,arrow-body-style */
    const fdcUserAppPermission = permissions
      .filter((c: any) => c.resourceCategoryCode === 'FDC')
      .map(
        (c: any) =>
          <UserPermission>{
            MayEdit: c.mayEdit,
            MayView: c.mayView,
            ResourceCategoryCode: c.resourceCategoryCode,
            ResourceName: c.resourceName
          }
      );

    const appMenu = (this.appMenuService.getAppMenu() || []).filter(app => {
      return permissions.some(
        (p: any) => p.resourceCategoryCode === app.resourceName
      );
    });

    const userDetail: UserDetails = {
      Applications: this.mergeAppMenu(appMenu),
      FirstName: 'firstName',
      LastName: 'lastName',
      LegacyUserName: '',
      LogOutLink: Config.app.logOutLink,
      Permissions: fdcUserAppPermission,
      SamAccountName: Config.user.name,
      UserEmailAddress: Config.user.name
    };
    /* eslint-enable */

    let filteredLeftmenu: NavigationResource[] = LeftMenu;


    const indexOfSupport = filteredLeftmenu.findIndex(x => x.label === 'Pinpoint Support');

    if (indexOfSupport > 0 && Config.app.supportResource) {
      filteredLeftmenu[indexOfSupport].permissionKey = Config.app.supportResource;
    }

    filteredLeftmenu = filteredLeftmenu.filter((item) => item.label !== 'Create Question');
    if (!this.userService.isCTQuestionEditor()) {
      filteredLeftmenu = filteredLeftmenu.filter((item) => item.label !== 'Create Question');
    }

    this.layoutService.setUserInfo(userDetail, filteredLeftmenu);

    this.layoutService.toggleSidebar();
  }

  ngAfterViewInit() {
    this.isLoading = false;
    this.loadingService.getIsLoading().subscribe(res => {
      if(res === true) {
        setTimeout(() => this.isLoading = this.loadingService.isLoading, 1500);
      } else {
        this.isLoading = false;
      }
    });
  }

  mergeAppMenu(appMenu: UserApplication[]): UserApplication[] {
    return [
      {
        application: '-- Select an Application --',
        resourceName: '',
        url: '',
        icon: ''
      },
      ...appMenu
    ];
  }
}
